"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sizeGuideDrawerInit = function () {
    var triggerButton = document.querySelector("[data-size-guide-trigger]");
    var drawer = document.querySelector("[data-size-guide-drawer]");
    var overlay = document.querySelector("[data-size-guide-overlay]");
    var closeButton = document.querySelector("[data-size-guide-close]");
    var toggleButtons = document.querySelectorAll(".size-guide-drawer .size-guide-toggle");
    // Unit toggle (cm/in) within drawer
    if (toggleButtons.length > 0) {
        toggleButtons.forEach(function (button) {
            button.addEventListener("click", function (e) {
                var clickedButton = e.currentTarget;
                var unit = clickedButton.dataset.unit;
                var container = clickedButton.closest(".size-guide-drawer");
                if (!unit || !container)
                    return;
                container.querySelectorAll(".size-guide-toggle").forEach(function (btn) {
                    btn.classList.remove("active");
                });
                clickedButton.classList.add("active");
                container
                    .querySelectorAll(".size-guide-table__content")
                    .forEach(function (table) {
                    var tableElement = table;
                    if (tableElement.dataset.unit === unit) {
                        tableElement.classList.add('active');
                    }
                    else {
                        tableElement.classList.remove('active');
                    }
                });
            });
        });
    }
    var openDrawer = function () {
        if (drawer && overlay) {
            drawer.classList.add("is-open");
            overlay.classList.add("is-visible");
            document.body.style.overflow = "hidden";
        }
    };
    var closeDrawer = function () {
        if (drawer && overlay) {
            drawer.classList.remove("is-open");
            overlay.classList.remove("is-visible");
            document.body.style.overflow = "";
        }
    };
    if (triggerButton) {
        triggerButton.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            openDrawer();
        });
    }
    if (closeButton) {
        closeButton.addEventListener("click", closeDrawer);
    }
    if (overlay) {
        overlay.addEventListener("click", closeDrawer);
    }
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && (drawer === null || drawer === void 0 ? void 0 : drawer.classList.contains("is-open"))) {
            closeDrawer();
        }
    });
};
exports.default = sizeGuideDrawerInit;
